import "./utils/yup";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { ApolloProvider } from "@apollo/client";
import { client } from "./services/graphql";
import { theme } from "./utils/theme";
import {
  CssBaseline,
  StyledEngineProvider,
  ThemeProvider,
} from "@mui/material";
import { SidebarProvider } from "./contexts";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "~/contexts";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <StyledEngineProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <BrowserRouter>
            <SidebarProvider>
              <AuthProvider>
                <>
                  <App />
                  <ToastContainer />
                </>
              </AuthProvider>
            </SidebarProvider>
          </BrowserRouter>
        </ThemeProvider>
      </StyledEngineProvider>
    </ApolloProvider>
  </React.StrictMode>,
);
